export const removeElementsByClass = className => dom => {
  Array.from(dom.getElementsByClassName(className)).forEach(e => {
    if (e.parentNode) e.parentNode.removeChild(e);
  })
};
